// extracted by mini-css-extract-plugin
export default {"cardItem":"styles_cardItem__ZH4ND","iconBox":"styles_iconBox__CcoFc","cardContent":"styles_cardContent__8gCyq"};